export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/it.e8e5a53a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};